module.exports = __webpack_public_path__ + "img/trace_code_result_feedback.e7a823c8.png";